import NavigationItemInterface from "@app/Interface/NavigationItemInterface";

export default class NavigationItemModel implements NavigationItemInterface {

    public id: number;
    public menu_item_id: number;
    public menu_order: number;
    public menu_item_parent: number;
    public object_id: number;
    public object: string;
    public type: string;
    public type_label: string;
    public url: string;
    public path: string;
    public title: string;
    public target: string;
    public description: string;
    public classes: [];
    public children: Array<NavigationItemInterface>;

    constructor() {

        this.id = 0;
        this.menu_item_id = 0;
        this.menu_order = 0;
        this.menu_item_parent = 0;
        this.object_id = 0;
        this.object = "";
        this.type = "";
        this.type_label = "";
        this.url = "";
        this.path = "";
        this.title = "";
        this.target = "";
        this.description = "";
        this.classes = [];
        this.children = [];

    }

}